
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import List from '@/common/components/UI/List/index.vue'
import RPListItem from '@/modules/RPModule/components/RPListItem/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import RPFilters from '@/modules/RPModule/components/RPFilters/index.vue'
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisations
import { rp } from '@/core/realisations/rp.realisation'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { RPT } from '@/core/types/rp.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'failed-fetch': FailedFetch,
        'rp-filters': RPFilters,
        'rp-list-item': RPListItem,
        'page-title': PageTitle,
        'the-button': TheButton,
        list: List,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_generating: false,
        })

        const data_state = reactive({
            rp: new DataState<RPT>({}),
        })

        const filters_state = reactive({
            id: undefined as number | undefined,
            createdAt: undefined as string | undefined,
        })

        const notifications = useNotifications()

        const loadRPList = async (page: number) => {
            data_state.rp.pagination.current_page = page

            const params = {
                page,
                id: filters_state.id,
                createdAt: filters_state.createdAt,
            }

            try {
                data_state.rp.is_loading = true
                const response = await rp.getList(params)

                data_state.rp.list = response.data
                data_state.rp.pagination.total_pages = response.meta.last_page

                data_state.rp.is_failed = false
                data_state.rp.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.rp.failure.catchError(error)

                if (!data_state.rp.failure.error_state.is_cancel) {
                    data_state.rp.is_failed = true
                }
            } finally {
                if (!data_state.rp.failure.error_state.is_cancel) {
                    data_state.rp.is_loading = false
                }
            }
        }

        const onSearch = (filters: { id: number; createdAt: string }) => {
            filters_state.id = filters.id
            filters_state.createdAt = filters.createdAt

            loadRPList(1)
        }

        const onReset = () => {
            filters_state.createdAt = undefined
            filters_state.id = undefined

            loadRPList(1)
        }

        const generateRP = async () => {
            try {
                state.is_generating = true

                const response = await rp.generateRP()
                notifications.notify({
                    title: response.message || 'РП сформирован',
                    type: 'success',
                })
                await loadRPList(1)
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: `Ошибка формирования РП`,
                })
            } finally {
                state.is_generating = false
            }
        }

        onBeforeMount(async () => {
            await loadRPList(1)
        })

        return {
            state,
            data_state,
            loadRPList,
            onSearch,
            onReset,
            generateRP,
        }
    },
})
